// @ts-nocheck
// Greif UI Kit = G+
import * as React from "react";
import uniqueId from "@insite/mobius/utilities/uniqueId";

const GreifPlus: React.FC = () => {
    const id = uniqueId();

    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path fill="#c4d600" d="M10.175 1.92 8.546 14.974l7.46-6.05.867-7.004z" />
            <path fill={`url(#${id})`} d="m8.546 14.973 6.266-.01h7.146l.747-6.04h-6.698z" />
            <path fill="#337761" d="M7.445 14.978h-6.15l.747-6.016h6.15zM15.136 16.02l-.802 6.06H7.63l.802-6.06z" />
            <defs>
                <linearGradient id={id} x1="5.005" x2="18.417" y1="11.948" y2="11.948" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#003575" />
                    <stop offset=".2" stopColor="#003c81" />
                    <stop offset=".58" stopColor="#0050a3" />
                    <stop offset="1" stopColor="#006cd0" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default React.memo(GreifPlus);
